import React from "react";
import { ActionButton, Tag, Thumbnail } from "@culturehq/components";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";
import getUserName from "app/utils/getUserName";

const UserRow = ({ onSelected, onUnselected, user }) => {
  const handleSelectUser = () => {
    onSelected(user);
  };
  const handleUnSelectUser = () => {
    onUnselected(user);
  };

  return (
    <tr>
      <td>
        <Thumbnail image={user.avatar.thumbUrl} title={getUserName(user)} />
      </td>
      <td className="profile-link">
        <ProfileLink user={user} />
        <br />
        {user.email}
      </td>
      <td className="actions">
        {!user.selected ? (
          <ActionButton onClick={handleSelectUser}>
            <Trans>Select</Trans>
          </ActionButton>
        ) : (
          <ActionButton className="actions-td" onClick={handleSelectUser}>
            <Trans>Selected</Trans>
          </ActionButton>
        )}
      </td>
    </tr>
  );
};

export default UserRow;
